import { NgModule, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterStateSnapshot } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HubModule } from '../../hub/hub.module';
import { PerfilModule } from '../../perfil/perfil.module';
import { BloquearPantallaModule } from '../../bloquear-pantalla/bloquear-pantalla.module';
import { AlumnoRoutingModule } from './alumno-routing.module';
import { PaginacionModule } from '../../parcial/paginacion/paginacion.module';

import { MenuModule } from '../../menu/menu.module';
import { ParcialModule } from '../../parcial/parcial.module';

import { ListaComponent } from './lista/lista.component';
import { AlumnoComponent } from './formulario/formulario.component';
import { VerComponent } from './ver/ver.component';


import { ReporteAlumnoComponent } from './reporte/reporte-alumno.component';
import { OperacionComponent } from './operacion/operacion.component';

import { AuthService } from '../../auth.service';

//crud
import { CrudService } from '../../crud/crud.service';
import { CrudModule }  from '../../crud/crud.module';
//fin crud
import { NgSelect2Module } from 'ng-select2';

import { TextMaskModule } from 'angular2-text-mask';
import { RevalidacionComponent } from './revalidacion/revalidacion.component';
import { RepeticionComponent } from './repeticion/repeticion.component';
import { NguiAutoCompleteModule } from '@ngui/auto-complete';
import { PipesModule } from 'app/pipes/pipes.module';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AlumnoRoutingModule,
    HubModule,
    PerfilModule,
    BloquearPantallaModule,
    MenuModule,
    ParcialModule,
    PaginacionModule,
    CrudModule,
    TextMaskModule,
    NgSelect2Module,
    
    NguiAutoCompleteModule,
    PipesModule
  ],
  declarations: [
    ListaComponent,
    AlumnoComponent,
    RevalidacionComponent,
    VerComponent,
    RepeticionComponent,
    ReporteAlumnoComponent,
    OperacionComponent
  ],
  providers: [ AuthService, CrudService ]
})
export class AlumnoModule { }
